module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-line",
    style: (_vm.controlStyle)
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "4px",
      "background-color": "#bbb"
    },
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "position": "relative",
      "top": "-4px"
    }
  }, _vm._l((_vm.availableStages), function(stage, index) {
    return _c('div', {
      key: index,
      staticClass: " status-stage",
      class: {
        completed: _vm.tagExists(stage)
      },
      style: (_vm.statusStageStyle)
    }, [(_vm.tagExists(stage)) ? _c('div', {
      staticClass: "stage-circle blue",
      style: (_vm.stageCircleStyle)
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("check")])], 1) : _c('div', {
      staticClass: "stage-circle",
      style: (_vm.stageCircleStyle)
    }, [_c('span', {
      staticStyle: {
        "padding-left": "7px"
      }
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "stage-label"
    }, [_vm._v(_vm._s(stage.name))]), _vm._v(" "), _c('div', {
      staticClass: "stage-sublabel"
    }, [_vm._v(_vm._s(_vm._f("date")(_vm.tagDate(stage))))]), _vm._v(" "), _c('div', {
      staticClass: "stage-namelabel"
    }, [_vm._v(_vm._s(_vm.tagUser(stage)))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bda9b36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/StatusLine.vue
// module id = 2591
// module chunks = 1